import React from 'react';
import PropTypes from 'prop-types';

import MuiDialog from '../MuiDialog/MuiDialog';

import { Box } from '@mui/material';

import { orange } from '@mui/material/colors';

// others
import UserGroupsSelections from './UserGroupsSelections';
import UserSelections from './UserSelections';

// restful
import { fetchUserByDomain } from 'restful';

const DIALOG_HEIGHT = '65vh';
function UserSelectionsMUIDialog({
	open,
	title,
	onClose,
	userGroups,
	renderAfterUserSelected,
	handleProcessSelectedUsers,
	notifyGeneral,
	disableConfirmBtnIfNoUserSelected,
	...rest
}) {
	const [selectedUserGroups, setSelectedUserGroups] = React.useState([]);

	const [usersOfSelectedUserGroups, setUsersOfSelectedUserGroups] = React.useState({
		users: [],
		selectedUserIds: [],
	});

	const handleUserGroupsSelectionFinish = React.useCallback(
		async (selectedUserGroups) => {
			const userGroupIds = selectedUserGroups.map((ug) => ug.id).join(',');
			fetchUserByDomain({
				queryParams: { userGroupIds, renewalDateFrom: new Date().toISOString().split('T')[0] },
			})
				.then((res) => {
					const users = res.data.results;
					setUsersOfSelectedUserGroups({ users, selectedUserIds: users.map((u) => u.id) });
				})
				.catch((err) => {
					const errMsg = err.response?.data?.message ?? err.message;
					notifyGeneral(errMsg, 'error');
				});
		},
		[notifyGeneral]
	);

	return (
		<MuiDialog
			open={open}
			size={'lg'}
			title={title}
			content={
				<Box
					sx={{
						height: usersOfSelectedUserGroups.users?.length > 0 ? DIALOG_HEIGHT : 'unset',
						minHeight: 300,
						display: 'flex',
						flexDirection: 'column',
					}}
				>
					{userGroups.length > 0 ? (
						<Box sx={{ maxHeight: 100, flex: '0 1 auto', backgroundColor: orange[50] }}>
							<UserGroupsSelections
								userGroups={userGroups}
								handleUserGroupsChange={(value) => {
									setSelectedUserGroups(value);
								}}
								onUserGroupsSelectionFinish={(value) =>
									handleUserGroupsSelectionFinish(value ?? selectedUserGroups)
								}
							/>
						</Box>
					) : null}
					{usersOfSelectedUserGroups.users.length > 0 ? (
						<Box
							sx={{
								mt: 1,
								flex: '1 1 auto',
								height: `calc(${DIALOG_HEIGHT} - 100px - ${
									usersOfSelectedUserGroups.selectedUserIds.length > 0 && renderAfterUserSelected
										? '100px'
										: '0px'
								})`,
							}}
						>
							<UserSelections
								users={usersOfSelectedUserGroups.users}
								selectedUserIds={usersOfSelectedUserGroups.selectedUserIds}
								handleUserSelectionChange={(selectedUserIds) =>
									setUsersOfSelectedUserGroups((previous) => {
										return { ...previous, selectedUserIds: selectedUserIds };
									})
								}
							/>
						</Box>
					) : null}
					{usersOfSelectedUserGroups.selectedUserIds.length > 0 && renderAfterUserSelected
						? renderAfterUserSelected(usersOfSelectedUserGroups.selectedUserIds)
						: null}
				</Box>
			}
			onClose={() => {
				setSelectedUserGroups([]);
				setUsersOfSelectedUserGroups({ users: [], selectedUserIds: [] });
				onClose();
			}}
			confirmCB={() => {
				const selectedUsers = usersOfSelectedUserGroups.users.filter((u) =>
					usersOfSelectedUserGroups.selectedUserIds.includes(u.id)
				);
				handleProcessSelectedUsers(selectedUsers);
			}}
			disableConfirmBtn={
				disableConfirmBtnIfNoUserSelected === false
					? false
					: usersOfSelectedUserGroups.selectedUserIds.length === 0
			}
		/>
	);
}

UserSelectionsMUIDialog.propTypes = {
	open: PropTypes.bool.isRequired,
	title: PropTypes.string.isRequired,
	userGroups: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string.isRequired,
			name: PropTypes.string.isRequired,
			userCount: PropTypes.number,
		})
	).isRequired,
	/**
	 * function to render when user is selected
	 * Note: the rendered the UI has max height 100px,
	 * 			 if height is over 100px, scrollbar of the dialog will appear
	 * @param {Array} selectedUserIds
	 */
	renderAfterUserSelected: PropTypes.func,
	disableConfirmBtnIfNoUserSelected: PropTypes.bool,

	/**
	 * @param {Event}
	 */
	onClose: PropTypes.func.isRequired,
	handleProcessSelectedUsers: PropTypes.func.isRequired,
	notifyGeneral: PropTypes.func.isRequired,
};

UserSelectionsMUIDialog.defaultProps = {
	disableConfirmBtnIfNoUserSelected: false,
	renderAfterUserSelected: null,
};

export default UserSelectionsMUIDialog;
